export default "__VITE_ASSET__B9uE80T6__"